import { useChainId } from 'wagmi'
import { PaymentMethod } from '../utils/Primitives'
import { getPrimaryExplorerUrl, formatEthAddress } from '../utils/GeneralUtilities'
import { useState } from 'react';

interface PaymentMethodInfoProps {
    paymentMethod: PaymentMethod;
}

export function PaymentMethodInfo({ paymentMethod }: PaymentMethodInfoProps) {
    const chainId = useChainId()
    const explorerUrl = getPrimaryExplorerUrl(chainId)
    const [showCopied, setShowCopied] = useState(false);

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            setShowCopied(true);
            setTimeout(() => setShowCopied(false), 2000); // Hide after 2 seconds
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div className='text-xs mt-2 text-gray-500 font-light'>
            {paymentMethod.id === 0 ? (
                <div>Payment Method {paymentMethod.id}: <span>Native Base ETH</span></div>
            ) : (
                <>
                    <div className="flex items-center gap-2">
                        Payment Method {paymentMethod.id}:{' '}
                        <a
                            href={`${explorerUrl}/address/${paymentMethod.address}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline"
                        >
                            {formatEthAddress(paymentMethod.address, 6)}
                        </a>
                        <button
                            onClick={() => copyToClipboard(paymentMethod.address)}
                            className="hover:text-gray-700"
                            title="Copy to clipboard"
                        >
                            📋
                        </button>
                    </div>
                    {showCopied && (
                        <div className="text-green-600 mt-1">
                            Copied to clipboard!
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
